export const PROJECT_SERVICE_CATEGORY_OPTIONS = [
    '领导力',
    'AI',
    '全球化业务人才',
    '团队发展',
    '战略共识分解',
    '1-1教练',
    '业务赋能',
    '软技能课程',
    '定制化项目',
    '其他项目',
];
